import React, { useState, useRef } from 'react';
import {
  DropdownMenu,
  DropdownItem,
  DropdownHeader,
  DropdownDivider,
  Dropdown,
  Input,
  Icon,
  Button,
} from 'semantic-ui-react';

const styles = document.createElement('style');
styles.innerHTML = `
  .non-active-item:hover {
    background-color: #eee !important;
  }
`;
document.head.appendChild(styles);

const DropdownFile = ({ label, userProjects = [] }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const searchInputRef = useRef(null);

  const handleSearchChange = (e, { value }) => {
    setSearchQuery(value);
  };

  const handleDropdownOpen = () => {
    setIsOpen(true);
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleClick = (e) => {
    e.stopPropagation();
  };

  const handleItemClick = (project) => {
    if (!project.opened) {
      window.open(project.url, '_self');
      handleClose();
    }
  };

  const filteredProjects = userProjects.filter((file) =>
    file.text.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Dropdown
        trigger={
          <Button 
            style={{
              backgroundColor: label === 'public' ? '#f4a261' : '#c2f0db',
              color: '#555555',
              border: 'none',
              boxShadow: 'none',
              display: 'flex',
              alignItems: 'center',
              padding: '6px 8px',
              fontSize: '14px',
              minWidth: label === 'public' ? '40px' : '60px',
              width: label === 'public' ? '40px' : '60px',
              height: '28px'
            }}
            compact
            size='mini'
            className='aligned'
          >
            {label === 'public' ? (
              <Icon name='folder open' style={{ margin: '0' }} />
            ) : (
              l.load
            )}
            <Icon name='dropdown' style={{ 
              marginLeft: '2px',
              fontSize: '12px',
              opacity: 0.8
            }} />
          </Button>
        }
        icon={null}
        floating
        pointing='top'
        className='link item custom-dropdown'
        open={isOpen}
        onOpen={handleDropdownOpen}
        onClose={handleClose}
        onClick={handleClick}
      >
        <Dropdown.Menu style={{ background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', minWidth: '300px', opacity: 1 }}>
          {userProjects.length > 10 && (
            <div className='ui input' style={{ 
              padding: '12px', 
              borderBottom: '1px solid #eaeaea',
              background: '#fff'
            }}>
              <Input
                transparent
                icon={<Icon name='search' style={{ color: '#666' }} />}
                iconPosition='left'
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder={l.search + '...'}
                ref={searchInputRef}
                onClick={(e) => e.stopPropagation()}
                size='small'
                style={{ 
                  width: '100%',
                  background: '#fff6d6',
                  border: '1px solid #ffe69c',
                  borderRadius: '4px',
                  padding: '6px 12px',
                  color: '#333',
                  '::placeholder': {
                    color: '#666',
                    opacity: 1
                  }
                }}
              />
            </div>
          )}
          <Dropdown.Header 
            content={l.projects} 
            style={{ 
              padding: '12px 16px',
              fontWeight: '600',
              color: '#333',
              fontSize: '14px',
              borderBottom: '1px solid #eaeaea'
            }}
          />
          <Dropdown.Menu scrolling style={{ 
            maxHeight: '400px', 
            padding: '8px 0',
            opacity: 1,
            background: '#fff'
          }}>
            {filteredProjects.map((file) => (
              <Dropdown.Item
                key={file.id}
                text={file.text}
                active={file.opened}
                disabled={file.opened}
                onClick={() => handleItemClick(file)}
                style={{
                  padding: '10px 16px',
                  color: file.opened ? '#fff' : '#333',
                  background: file.opened ? '#E45149' : 'transparent',
                  transition: 'background-color 0.2s ease',
                  cursor: file.opened ? 'default' : 'pointer',
                  fontWeight: file.opened ? '500' : 'normal',
                  opacity: 1
                }}
                className={!file.opened ? 'non-active-item' : ''}
              />
            ))}
          </Dropdown.Menu>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default DropdownFile;
